<template>
  <el-container class="home-container">
    <el-header class="homeHeader">
      <div class="title">南通报业集团小程序后管理系统</div>
      <el-dropdown class="userinfo" @command="handleCommand">
        <span class="el-dropdown-link">
          {{ username }}
          <img :src="avater" alt="" />
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="1">个人中心</el-dropdown-item>
          <el-dropdown-item command="2" divided>设置</el-dropdown-item>
          <el-dropdown-item command="3" divided>注销登录</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </el-header>
    <el-container>
      <el-aside width="200px">
        <el-menu
          background-color="#333744"
          text-color="#fff"
          active-text-color="#409BFF"
          unique-opened
          router
          :default-active="activePath"
        >
          <el-submenu
            :index="item.id + ''"
            v-for="item in menuList"
            :key="item.id"
          >
            <template slot="title">
              <!-- <i class="el-icon-location"></i> -->
              <i :class="item.icon"></i>
              <span>{{ item.name }}</span>
            </template>
            <el-menu-item
              @click="saveNavState('/' + subItem.path)"
              :index="'/' + subItem.path + ''"
              v-for="subItem in item.children"
              :key="subItem.id"
            >
              <template slot="title">
                <!-- <i class="el-icon-menu"></i>
                 -->
                <i :class="subItem.icon"></i>
                <span>{{ subItem.name }}</span>
              </template>
            </el-menu-item>
          </el-submenu>
        </el-menu>
      </el-aside>

      <el-main height="">
        <!-- Main content -->
        <router-view />
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import { GetMenuAuthRouter } from "@/request/api.js";
export default {
  data() {
    return {
      activePath: "",
      menuList: [],
      authList: [],
      routerList: [],
      avater: "",
      username: "",
    };
  },
  created() {
    this.getMenuList();

    this.activePath = sessionStorage.getItem("activePath");
  },
  methods: {
    handleCommand(command) {
      switch (command) {
        case "1":
          break;
        case "2":
          break;
        case "3":
          this.$confirm("确定要注销吗 ?", "系统提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }).then(async () => {
            window.sessionStorage.clear();
            this.$router.push("/login");
          });
          break;
      }
    },
    saveNavState(activePath) {
      sessionStorage.setItem("activePath", activePath);
      this.activePath = activePath;
    },

    async getMenuList() {
      const param = {};
      param.userid = sessionStorage.getItem("userid");

      console.log(sessionStorage.getItem("token"));
      this.avater = sessionStorage.getItem("avater");
      this.username = sessionStorage.getItem("username");
      GetMenuAuthRouter(param).then((res) => {
        console.log("res--->", res.data.menuList);
        if (res.data.code === 0) return this.$message.error(res.data.msg);
        this.menuList = res.data.menuList;
        this.authList = res.data.authList;
        this.routerList = res.data.routerList;
        console.log(this.menuList, this.authList, this.routerList);
        //存储菜单数据
        sessionStorage.setItem("menuList", JSON.stringify(this.menuList));
        //存储路由数据
        sessionStorage.setItem("routerList", JSON.stringify(this.routerList));
        //权限
        sessionStorage.setItem("authList", JSON.stringify(this.authList));
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.home-container {
  height: 100%;
}
// .el-header {
//   background-color: #373d41;
//   display: flex;
//   justify-content: space-between;
//   padding-left: 0;
//   align-items: center;
//   color: #fff;
//   font-size: 20px;

//   > div {
//     display: flex;
//     align-items: center;
//     img {
//       display: flex;
//       width: 40px;
//       height: 40px;
//     }
//     span {
//       margin-left: 10px;
//     }
//   }
// }
.el-aside {
  background-color: #333744;
  .el-menu {
    border-right: none;
  }
}

.el-main {
  background-color: #eaedf1;
}

.homeHeader {
  background: #409eff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 15px;
  box-sizing: border-box;
}

.title {
  font-size: 30px;
  font-family: 华文楷体;
  color: white;
}

.homeHeader .userinfo {
  cursor: pointer;
  display: flex;
}
.el-dropdown-link{
    color: white;
}
.el-dropdown-link img {
  height: 48px;
  width: 48px;
  border-radius: 50%;
  margin-left: 8px;

}
</style>
